import { NgForm } from '@angular/forms';

export class FormsUtils {

  public static markFormAsPristine(form: NgForm): void {
    Object.keys(form.controls).forEach(control => {
      form.controls[control].markAsPristine();
    });
  }
}
